import React, { useRef } from "react";
import Input from "@mui/material/Input";
import IconButton from "@mui/material/IconButton";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import NewsLetterService from "services/newsletter.service";
import { useSnackbar } from "notistack";
import { useErrorHandler } from "../../hooks";
import { Controller, useForm } from "react-hook-form";
import { FormHelperText } from "@mui/material";
import resolver from "./newsLetterSubscribeFormValidation";

export const NewsLetterSubscribe = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { handleError } = useErrorHandler();
  const joinNewsLetterInput = useRef<HTMLInputElement>(null);

  const { control, handleSubmit } = useForm<{ email: string }>({
    defaultValues: {
      email: "",
    },
    resolver,
  });

  const handleSubscribeNewsLetter = async () => {
    const email = joinNewsLetterInput && joinNewsLetterInput?.current?.value;
    try {
      if (email) {
        await NewsLetterService.subscribeToNewsletter(email);

        enqueueSnackbar("Successfully subscribed to newsletter", {
          title: "Approved!",
          variant: "success",
        });
      }
    } catch (e) {
      handleError(e, "It was not possible to subscribe");
    }
  };
  return (
    <form className="w-full mt-6" onSubmit={(e) => e.preventDefault()}>
      <Controller
        name="email"
        control={control}
        defaultValue=""
        render={({ field, fieldState }) => (
          <>
            <Input
              {...field}
              error={Boolean(fieldState?.error)}
              className="dataset-input rounded-3xl w-full py-0 font-normal"
              placeholder="Enter your email"
              disableUnderline
              style={{ marginTop: "unset" }}
              inputRef={joinNewsLetterInput}
              onMouseDown={(e) => e.preventDefault()}
              endAdornment={
                <IconButton
                  className="p-1 mr-[-5px] bg-primary"
                  onClick={handleSubmit(handleSubscribeNewsLetter)}
                >
                  <ArrowRightAltIcon style={{ color: "#fff" }} />
                </IconButton>
              }
            />
            {fieldState?.error && (
              <FormHelperText error>{fieldState.error.message}</FormHelperText>
            )}
          </>
        )}
      />
    </form>
  );
};
